module.exports = {"version":"1.9.75"}


//////////////////
// WEBPACK FOOTER
// ./static/auto-generated.json
// module id = 839
// module chunks = 0